// extracted by mini-css-extract-plugin
export default {"title":"typography_title__Tc3Ze","subtitle":"typography_subtitle__nacsb"};